import { useState } from "react";
import Configration from "./Child/Configration/Configration";
import JotForm from "./Child/JotForm/JotForm";
import Services from "./Child/Services/Services";
import Setting from "./Child/Setting/Setting";

const ConfigurationSetup = (props) => {
  const [CurTab, setCurTab] = useState("Configration Detail");
  const [check, setCheck] = useState(true);

  const ShowTab = (type) => {
    setCurTab(type);
    if (type === "Configration Detail") {
      setCheck(!check);
    }
  };

  return (
    <div className="tab-content">
        <div className="tab-pane active">
          <div className="client-section">
            <div className="row table-panel-header">
              <div className="col-md-4 col-sm-12">
                <h6>
                  {CurTab} <span className="text-lg text-red-500">*</span>{" "}
                </h6>
              </div>
              <div className="col-md-8 col-sm-12 text-right">
                <input
                  type="button"
                  className={`${
                    CurTab === "Configration Detail"
                      ? "configBtn text-white"
                      : ""
                  } btnLinkGreen btnUpdate`}
                  value="Configurations"
                  onClick={() => ShowTab("Configration Detail")}
                />
                <input
                  type="button"
                  className={`${
                    CurTab === "Services" ? "configBtn text-white" : ""
                  } btnLinkGreen btnUpdate`}
                  value="Services"
                  onClick={() => ShowTab("Services")}
                />
                <input
                  type="button"
                  className={`${
                    CurTab === "Setting" ? "configBtn text-white" : ""
                  } btnLinkGreen btnUpdate`}
                  value="Setting"
                  onClick={() => ShowTab("Setting")}
                />
                <input
                  type="button"
                  className={`${
                    CurTab === "JotForm Setup" ? "configBtn text-white" : ""
                  } btnLinkGreen btnUpdate`}
                  value="JotForms Setup"
                  onClick={() => ShowTab("JotForm Setup")}
                />
              </div>
            </div>
            {CurTab === "Services" ? (
              <Services entityId={props.entityId} />
            ) : (
              ""
            )}

            {CurTab === "Setting" ? <Setting entityId={props.entityId} /> : ""}

            {CurTab === "JotForm Setup" ? (
              <JotForm entityId={props.entityId} />
            ) : (
              ""
            )}
            {CurTab === "Configration Detail" ? (
              <Configration check={check} />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
  );
};

export default ConfigurationSetup;
